
define('eteration/widgets/ui-datepicker',[ 'knockout', 'eteration/widgets/widget-util','eteration/ui/validation-helper', 'moment'], function(ko, widgetUtil,validation, moment) {

	var self = this;
	
	widgetUtil.setupStringBasedTemplate(ko);
	var isOneWayCheckbox, containerId;
	var startDateCmp ;
	var endDateCmp ;
	self.keydown = null;
	var waveFlag;
	var beforeShowDay;
	var valueAccessorUnwrapped, i;
	
    function _setupComponent(element, valueAccessor) {
		
    	valueAccessorUnwrapped = ko.unwrap(valueAccessor())
    	
    	waveFlag = valueAccessorUnwrapped.mexicanWave || false;
    	var single = valueAccessorUnwrapped.single;
		var firstDate = valueAccessorUnwrapped.firstDate;
		var secondDate = valueAccessorUnwrapped.secondDate;	
		var onSelectCallback = valueAccessorUnwrapped.onSelectCallback;
		var numberOfMonths = ($(window).width() < 992) ? 1 : valueAccessorUnwrapped.numberOfMonths || 2;
	    var curDate = ko.unwrap(firstDate);
	    var promotionDates = valueAccessorUnwrapped.promotionDates;
	    var outboundSelectionNotification = valueAccessorUnwrapped.outboundSelectionNotification;
	    var inboundSelectionDirection = valueAccessorUnwrapped.inboundSelectionDirection;
	    var inboundSelectionNotification = valueAccessorUnwrapped.inboundSelectionNotification;
	    var accessibilityNotificationFieldId = valueAccessorUnwrapped.accessibilityNotificationFieldId || '';
		var gotoCurrent = valueAccessorUnwrapped.gotoCurrent;
		var generalBookerType = valueAccessor().type || false;

		if(gotoCurrent === undefined) {
			gotoCurrent = true;
		}
		if(curDate) {
			setTimeout(function() {
				$(element).datepicker("setDate",moment(curDate,"YYYYMMDD").format("MM/DD/YYYY"));	
			}, 2000);
		}
		var containerId = valueAccessorUnwrapped.containerId ? '#' + valueAccessorUnwrapped.containerId : '#calendarHolder'; 
		var container = $(containerId);
		var multiDateDisabled = valueAccessorUnwrapped.multiDateDisabled || false;
		var responseArrived = valueAccessorUnwrapped.responseArrived;
		if(responseArrived && $.isFunction(responseArrived)) {
			responseArrived.subscribe(function(newValue) {
				if(newValue && !ko.unwrap(single)) {
					$(containerId).removeClass('isOneWay');
				}
				curDate = firstDate();
				if(curDate) {
				   setTimeout(function() {
					   $(element).datepicker("setDate",moment(curDate,"YYYYMMDD").format("MM/DD/YYYY"));	
				   }, 2000);
				}
	    	});
    	}
		
		var disabledRanges = valueAccessorUnwrapped.disabledRanges || [];
		
		disabledRanges = ko.unwrap(disabledRanges);
		
		var maxDay = ko.unwrap(valueAccessorUnwrapped.maxDay);
		
		var maxDate = ko.unwrap(valueAccessorUnwrapped.maxDate);
		
		maxDay = maxDay ? maxDay + 'D' : '355D';
		
		if(maxDate) {
			maxDay = maxDate;
		}
		
		var minDate = ko.unwrap(valueAccessorUnwrapped.minDate);
		
		if(minDate == null) {
			minDate = 0;
		} else {
			if(minDate.toDate) {
				minDate = minDate.toDate();
			}
		}

		//Defect: Number of months for mobile should be 1 fixed by SJ
		
		if(numberOfMonths === 1) {
			container.addClass('single-calendar');
		}

		var days = moment().localeData()._weekdaysMin;
		var weekdays = moment().localeData()._weekdays;

		var months = moment().localeData()._months;
		
		if (ko.unwrap(single)) {
			container.addClass('isOneWay');
		} else {
			container.removeClass('isOneWay');
		}

		$('.popup-wrapper').on('click', function(e) {
			var dropdownSelect = $(e.target).closest(".dropdownselect");
			if ( dropdownSelect.length ) {
				if ($(e.target).closest(".dropdown-menu").length ) {
					// unintentedly popup closing when selection from opened dropdown menu fix
					dropdownSelect.removeClass('open');
					e.stopImmediatePropagation();
				}
				return;
			}
			e.stopImmediatePropagation();
		});

		$(containerId + ' .clearDates-component-selector-class').on('click', function(e) {
			firstDate('');
			secondDate('');

			$(element).datepicker('setDate',null);
			
			$('.dp-highlight').removeClass('dp-highlight');
			$('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
			$('.ui-state-active').removeClass('ui-state-active');

			startDateCmp = null;
			endDateCmp = null;
			
			if(!multiDateDisabled) {
				single(false);
			}//general booker tamamen kullanıldığında bu kısım gereksiz kalacak
			
			if($('.general-booker').length > 0 && generalBookerType) {
				var m = $('.general-booker .mini-booker-link.active').attr('data-type');
				generalBookerType(m);
				if(m != 'round') single(true);
				else single(false);
			}

			if (!$(this).is('disabled')) {
				$(this).addClass('disabled').attr('tabindex', '-1');
			}
			e.stopPropagation();
			e.stopImmediatePropagation();
			return true;
		});

		if ($(containerId + ' .isOneWayTicket-component-selector-class').parent().hasClass('metro-checkbox')) {
			isOneWayCheckbox = $(containerId + ' .isOneWayTicket-component-selector-class').parent();
		} else {
			isOneWayCheckbox = $(containerId + ' .isOneWayTicket-component-selector-class');
		}
		
		var isGeneralBooker = false;
		if($(element).parents('.tk-booker.general-booker').length) {
			isOneWayCheckbox = ($(element).parents('.tk-booker').hasClass('general-booker') ?
					$(element).parents('.general-booker').find('[data-type=oneway].mini-booker-link,[data-type=round].mini-booker-link,[data-type="toggle"].isOneWayTicket-component-selector-class') : isOneWayCheckbox);
			isGeneralBooker = true;
		}

		if (isOneWayCheckbox.attr('type') === 'radio') {
			isOneWayCheckbox.parents('.ui-datepicker-wrapper-header').on('change', checkOneWay);
		} else {
			isOneWayCheckbox.on('click', checkOneWay);
		}

		function checkOneWay(e) {
			var isOneWay = $(containerId + ' .isOneWayTicket-component-selector-class').is(':checked');
			isOneWay = isGeneralBooker ? ($(this).attr('data-type') == 'oneway') : isOneWay;

			if (isOneWay) {
				$(containerId + ' .calendarValue-component-selector-class').addClass('isOneWay');
				$(containerId).addClass('isOneWay');
				$('.dp-highlight').each(function(index) {
					$(this).addClass('dp-disabled');
				});
			} else {
				$(containerId + ' .calendarValue-component-selector-class').removeClass('isOneWay');
				$(containerId).removeClass('isOneWay');
				$('.dp-highlight').each(function() {
					var self = $(this);
					self.removeClass('dp-disabled');
					if (!self.is('.ui-datepicker-current-day')) {
						$(this).removeClass('dp-highlight');
						$(this).find('ui-state-active').removeClass('ui-state-active');
					}
				});
			}

			secondDate('');
			endDateCmp = null;
			$('.ui-state-active').each(function(i) {
				if ( i !== 0 ) {
					$(this).removeClass('ui-state-active');
					$(this).parent().removeClass('dp-highlight');
					$(this).parent().removeClass('ui-datepicker-current-day');
				}
			});

			var curDate = firstDate();
			if(curDate && gotoCurrent) {
				$(element).datepicker("setDate",moment(curDate,"YYYYMMDD").format("MM/DD/YYYY"));
			}
			$(element).datepicker('refresh');
			e.stopPropagation();
			e.stopImmediatePropagation();
			return true;
		}
		
		var dateRange = [];          

		for (i = 0; i < disabledRanges.length; i++) {
			for (var d = new Date(disabledRanges[i].startDate); d <= new Date(disabledRanges[i].endDate); d.setDate(d.getDate() + 1)) {
				var formattedRangeItem = $.datepicker.formatDate('yy-mm-dd', d);
				if(firstDate() && formattedRangeItem === $.datepicker.formatDate('yy-mm-dd', firstDate())) {
					firstDate('');
					secondDate('');
					$('[href=' + containerId + ']').trigger('click');
				}
				
				if(secondDate() && formattedRangeItem === $.datepicker.formatDate('yy-mm-dd', secondDate())) {
					firstDate('');
					secondDate('');
					$('[href=' + containerId + ']').trigger('click');
				}
				
				dateRange.push(formattedRangeItem);
			}
		}
		
		// populate the array
		beforeShowDay = function(date) {
			try {
				setTimeout(function () {
					$('.ui-datepicker .today-not-selected.ui-datepicker-today a.ui-state-default').removeClass('ui-state-highlight ui-state-hover ui-state-active');
				}, 300);
				
				var dateString = jQuery.datepicker.formatDate('yy-mm-dd', date);
				
				var enabled = dateRange.indexOf(dateString) === -1
				
				var clazz = "";
				
				var currentTime = moment.utc(date, "YYYYMMDD").unix()*1000;
				
				var fDateStr = moment.utc(firstDate()).format("YYYYMMDD");
				
				var sDateStr = (secondDate && secondDate()) ? moment.utc(ko.unwrap(secondDate)).format("YYYYMMDD") : null;
				
				if(currentTime>firstDate() && currentTime<ko.unwrap(secondDate)) {
					clazz = 'dp-highlight';
				}
				
				var isCurrentDateSelected = fDateStr == date || sDateStr == date;
				if(isCurrentDateSelected) {
					clazz = "ui-state-active";
				} else if(date.toString() == moment.utc().toDate().toString()) {
					clazz="today-not-selected";
				}
				
				if(!isCurrentDateSelected) {
					var firstDateSelected = !(!firstDate() || firstDate() === "");
					clazz += " " + paintPromotionDay(promotionDates, currentTime, firstDateSelected);
				}
				
				return [ enabled,  clazz];

			} catch (e) {
				console.dir(e);
			}
		}
		
		var formatDate = function(date) {
			return moment.utc(date, "YYYYMMDD").unix()*1000;
		}
		
		var paintPromotionDay = function(promotionDatesObservable, dateOfDay, isAnyDateSelected) {
			if(!promotionDatesObservable) {
				return '';
			}
			var promotionDates = promotionDatesObservable();
			if(!promotionDates) {
				return '';
			}
			var departureStart = formatDate(promotionDates.departuredateinterval_startdate);
			var departureEnd = formatDate(promotionDates.departuredateinterval_enddate);
			var returnStart = formatDate(promotionDates.returndateinterval_startdate);
			var returnEnd = formatDate(promotionDates.returndateinterval_enddate);
			
			var isDayInDepartureInterval = promotionDates.departuredateinterval_startdate &&
										   dateOfDay >= departureStart &&
										   dateOfDay <= departureEnd;
			var isDayInReturnInterval = promotionDates.returndateinterval_startdate && 
										dateOfDay >= returnStart && 
										dateOfDay <= returnEnd;
			
			var isDeparturePromotion = false;
			var isArrivalPromotion = false;
			
			if(isDayInDepartureInterval) {
				var invalidDepartureDate = false;
				var invalidDepartureStartDates = [];
				var invalidDepartureEndDates = [];
				
				if(promotionDates.invaliddeparturedateinterval_startdate) {
					if(!Array.isArray(promotionDates.invaliddeparturedateinterval_startdate)) {
						invalidDepartureStartDates.push(promotionDates.invaliddeparturedateinterval_startdate);
					} else {
						invalidDepartureStartDates = promotionDates.invaliddeparturedateinterval_startdate;
					}
					
					if(!Array.isArray(promotionDates.invaliddeparturedateinterval_enddate)) {
						invalidDepartureEndDates.push(promotionDates.invaliddeparturedateinterval_enddate);
					} else {
						invalidDepartureEndDates = promotionDates.invaliddeparturedateinterval_enddate;
					}
					
					for(i = 0; i < invalidDepartureStartDates.length; i++) {
						var invalidDepartureStart = formatDate(invalidDepartureStartDates[i]);
						var invalidDepartureEnd = formatDate(invalidDepartureEndDates[i]);
						if(dateOfDay >= invalidDepartureStart && dateOfDay <= invalidDepartureEnd) {
							invalidDepartureDate = true;
						}
					}
				}
				
				if(!invalidDepartureDate) {
					isDeparturePromotion = true;
				}
			} 
			
			if(isDayInReturnInterval) {
				var invalidReturnDate = false;
				var invalidReturnStartDates = [];
				var invalidReturnEndDates = [];
				
				if(promotionDates.invalidarrivaldateinterval_startdate) {
					if(!Array.isArray(promotionDates.invalidarrivaldateinterval_startdate)) {
						invalidReturnStartDates.push(promotionDates.invalidarrivaldateinterval_startdate);
					} else {
						invalidReturnStartDates = promotionDates.invalidarrivaldateinterval_startdate;
					}
					
					if(!Array.isArray(promotionDates.invalidarrivaldateinterval_enddate)) {
						invalidReturnEndDates.push(promotionDates.invalidarrivaldateinterval_enddate);
					} else {
						invalidReturnEndDates = promotionDates.invalidarrivaldateinterval_enddate;
					}
					
					
					for(i = 0; i < invalidReturnStartDates.length; i++) {
						var invalidReturnStart = formatDate(invalidReturnStartDates[i]);
						var invalidReturnEnd = formatDate(invalidReturnEndDates[i]);
						if(dateOfDay >= invalidReturnStart && dateOfDay <= invalidReturnEnd) {
							invalidReturnDate = true;
						}
					}
				}
				
				if(!invalidReturnDate) {
					isArrivalPromotion = true;
				}
			}
			
			
			if(isDeparturePromotion && isArrivalPromotion) {
				return "promotion-intersection";
			}
			
			if(isDeparturePromotion) {
				return "promotion-start";
			}
			
			if(isArrivalPromotion) {
				return "promotion-end";
			}
			
			return '';
		}
		
		$(function() {
		    $(".datepicker").datepicker();
		    $(element).addClass('notranslate');
		});
		
		$(element).datepicker({
			numberOfMonths : numberOfMonths,
			minDate : minDate,
			firstDay : 1,
			maxDate : maxDay,
			defaultDate : null,
			monthNames : months,
			dayNamesMin : days,
			dayNames : weekdays,
			dayNamesShort : days,
			changeMonth : false,
			changeYear : false,
			showButtonPanel : false,
			gotoCurrent: gotoCurrent,
			autoclose : false,
			beforeShowDay : beforeShowDay,
			onSelect : function(dateText) {
				var selectedDate = new Date(dateText);
				selectedDate = moment.utc(dateText,"MM/DD/YYYY").toDate()
				
				if(selectedDate.toString() == moment.utc().toString()) {
					setTimeout(function() { $(".today-not-selected").removeClass("today-not-selected"); }, 300);
				}
				
				var notificationField = $('#' + accessibilityNotificationFieldId);
				var notificationText = '';
				if (ko.unwrap(single)) {
					firstDate(selectedDate);
					startDateCmp = selectedDate;
					
					if (secondDate) {
						secondDate('');
						endDateCmp = null;
					}
					
					notificationText = outboundSelectionNotification;

				} else {
					var outboundNotification = outboundSelectionNotification + inboundSelectionDirection;
					if ((validation.isEmptyValue(firstDate()) && validation.isEmptyValue(secondDate())) || (!validation.isEmptyValue(firstDate()) && !validation.isEmptyValue(secondDate()))) {
						firstDate(selectedDate);
						
						notificationText = outboundNotification;
						startDateCmp = selectedDate;
						secondDate('');
						endDateCmp = null;
					} else {
						var oldDate = firstDate();
						var newDate = selectedDate;

						if (moment.utc(oldDate).isAfter(newDate)) {
							secondDate(oldDate);
							firstDate(selectedDate);
							notificationText = outboundNotification;
							
							startDateCmp = selectedDate;
							endDateCmp = oldDate;
						} else {
							secondDate(selectedDate);
							notificationText = inboundSelectionNotification;
							firstDate(oldDate);
							startDateCmp = oldDate;
							endDateCmp = selectedDate;								
						}
					}

					if(notificationField.length > 0) {
						notificationField.text(notificationText);
					}
				}

				$(containerId + ' .clearDates-component-selector-class').removeClass('disabled').attr('tabindex', '0');
				$('.ui-datepicker-current-day').removeClass('ui-state-hover');
				
				if(onSelectCallback) {
					onSelectCallback();
				}
			},
			onAfterUpdate : function() {
				$('<button type="button" class="ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all" data-handler="hide" data-event="click">Done</button>').appendTo($(containerId + ' .jrange-component-selector-class div .ui-datepicker-buttonpane')).on('click', function() {
					$(containerId + ' .jrange-component-selector-class div').hide();
				});
			},
			onChangeMonthYear : function() {
				$('.ui-state-active').each(function() {
					$(this).removeClass('ui-state-active');
				});			
			} 
		}).show();

		self.keydown = function(event) {
    	   _doKeyDown(event, element);
		};
		
		var popupEl = $(element).closest('.popup');
		

		
		popupEl.on('popupOpened', function() {		
			$('body').unbind('keydown');
			$('body').bind('keydown', self.keydown);
			if((!firstDate() && !generalBookerType) ||
					(typeof generalBookerType == 'function' && !firstDate())) {
				$(this).find('.ui-state-active').removeClass('ui-state-active');
			}
			if(window.isPhone) {
				$('html, body').animate({scrollTop: 0 });
			}


		});
		
		popupEl.on('popupClosed', function() {
			if(popupEl[0] && popupEl[0].id != "singleCityCalendarHolderForTravelPackage" && popupEl[0].id != "singleCityCalendarHolderForMileageCalculator"){
				if($('.general-booker').length > 0 && firstDate() && !secondDate() && generalBookerType && !multiDateDisabled) {
					generalBookerType('oneway');
					single(true);
				}
				$('body').unbind('keydown');
			}
		});

	}
	
	function _doKeyDown(event, element) {

		var proto = $.datepicker,
		    popup = $(element).closest('.popup'),
			inst = $(element).data('datepicker'),
			focusable_items = popup.find('.focusable-calendar-item'),
			handled = true,
			isRTL = false;
		
		inst._keyEvent = true;
		if (popup.hasClass('on')) {
			switch (event.keyCode) {
				case 9:
					if(document.activeElement) {
						var $activeElement = $(document.activeElement);
						
						var isActiveElementDatepickerDay = $activeElement.hasClass('ui-state-default');
						var isOneofFocusableCalendarItem = $activeElement.hasClass('focusable-calendar-item');
						var isActvieElementPrevMonthButton = $activeElement.hasClass('ui-datepicker-prev');
						var isActiveElementOneWayTicketItem = $activeElement.hasClass('isOneWayTicket-component-selector-class');
						var isClearAllDatesButtonDisabled = popup.find('.clearDates-component-selector-class').hasClass('disabled');
						var isPrevMonthButtonDisabled = popup.find('.ui-datepicker-prev').hasClass('ui-state-disabled');
						
						if(document.activeElement.id == "calendarTrigger") {
							focusable_items.first().focus();
						} else if(isActiveElementDatepickerDay) {
							popup.find('.ui-datepicker-next').focus();
						} else if(isActvieElementPrevMonthButton || (isActiveElementOneWayTicketItem && isClearAllDatesButtonDisabled && isPrevMonthButtonDisabled)) {
							var activeHover = popup.find('.ui-state-hover');
							if(activeHover.length > 0) {
								activeHover.first().focus();
							} else {
								popup.find('.ui-datepicker-today').children('a').focus();
							}
						} else if(isOneofFocusableCalendarItem) {
							handled = false;
						} else {
							focusable_items.first().focus();
						}
					} else {
						handled = false;
					}
					break;
				case 13: 
						if(document.activeElement && $(document.activeElement).hasClass('ui-state-default')) {
							var sel = $("td." + proto._dayOverClass + ":not(." + proto._currentClass + ")", inst.dpDiv); //enter
							if(sel[0]) {
								proto._selectDay(element, inst.selectedMonth, inst.selectedYear, sel[0]);
							} else {
								handled = false;
							}
						} else {
							$(document.activeElement).click();

						}
						break;
				case 27: popup.trigger('click');
						break; // hide on escape
				case 33: proto._adjustDate(element, (event.ctrlKey ?
							-proto._get(inst, "stepBigMonths") :
							-proto._get(inst, "stepMonths")), "M");
						break; // previous month/year on page up/+ ctrl
				case 34: proto._adjustDate(element, (event.ctrlKey ?
							+proto._get(inst, "stepBigMonths") :
							+proto._get(inst, "stepMonths")), "M");
						break; // next month/year on page down/+ ctrl
				case 35: if (event.ctrlKey || event.metaKey) {
							$(containerId + ' .clearDates-component-selector-class').click();
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: proto._gotoToday(element);
						
						break; // current on ctrl or command +home
				
				case 37: proto._adjustDate(element, (isRTL ? +1 : -1), "D");
						// -1 day on ctrl or command +left
						$('.popup-wrapper .focusable-calendar-item').blur();
						if (event.originalEvent.altKey) {
							proto._adjustDate(element, (event.ctrlKey ?
								-proto._get(inst, "stepBigMonths") :
								-proto._get(inst, "stepMonths")), "M");
						}
						popup.find('.ui-state-hover').focus();
						// next month/year on alt +left on Mac
						break;
				
				case 38: 
					proto._adjustDate(element, -7, "D");
					$('.popup-wrapper .focusable-calendar-item').blur();
					popup.find('.ui-state-hover').focus();
					break; // -1 week on ctrl or command +up
				
				case 39:
					// +1 day on ctrl or command +right
					if (event.originalEvent.altKey) {
						proto._adjustDate(element, (event.ctrlKey ?
							+proto._get(inst, "stepBigMonths") :
							+proto._get(inst, "stepMonths")), "M");
					} else {
						proto._adjustDate(element, (isRTL ? -1 : +1), "D");
					}
					$('.popup-wrapper .focusable-calendar-item').blur();
					popup.find('.ui-state-hover').focus();
					break;
					// next month/year on alt +right
				case 40: proto._adjustDate(element, +7, "D");
						$('.popup-wrapper .focusable-calendar-item').blur();
						popup.find('.ui-state-hover').focus();
						break; // +1 week on ctrl or command +down
				case 45: if (event.ctrlKey || event.metaKey) {
					isOneWayCheckbox.trigger('click');
				}
				handled = event.ctrlKey || event.metaKey;
				break; 
				default: handled = false;
				break;
			}
		}  else {
			handled = false;
		}
		if (handled) {
			event.preventDefault();
			event.stopPropagation();
		}
	}
	
	ko.bindingHandlers.datepicker = {

		setupComponent : _setupComponent,	
		init : function(element, valueAccessor, allBindingsAccessor) {
						
			Date.prototype.toString = function() {
				 var yyyy = this.getFullYear().toString();
				 var mm = (this.getMonth()+1).toString(); // getMonth() is zero-based
				 var dd  = this.getDate().toString();
				 return yyyy + (mm[1]?mm:"0"+mm[0]) + (dd[1]?dd:"0"+dd[0]); // padding
			};
			
			ko.bindingHandlers.datepicker.setupComponent(element, valueAccessor, allBindingsAccessor);
			if(valueAccessorUnwrapped.maxDate && $.isFunction(valueAccessorUnwrapped.maxDate)) {
				valueAccessorUnwrapped.maxDate.subscribe(function() {
					$(element).datepicker('destroy');
		    		ko.bindingHandlers.datepicker.setupComponent(element, valueAccessor, allBindingsAccessor);
		    		
		    	});
	    	}
			
			if(valueAccessorUnwrapped.maxDay && $.isFunction(valueAccessorUnwrapped.maxDay)) {
				valueAccessorUnwrapped.maxDay.subscribe(function() {
					$(element).datepicker('destroy');
		    		ko.bindingHandlers.datepicker.setupComponent(element, valueAccessor, allBindingsAccessor);
		    		
		    	});
	    	}
			
			if(valueAccessorUnwrapped.minDate && $.isFunction(valueAccessorUnwrapped.minDate)) {
				valueAccessorUnwrapped.minDate.subscribe(function() {
					$(element).datepicker('destroy');
		    		ko.bindingHandlers.datepicker.setupComponent(element, valueAccessor, allBindingsAccessor);
		    		
		    	});
	    	}
						
			if(valueAccessorUnwrapped.disabledRanges && $.isFunction(valueAccessorUnwrapped.disabledRanges)) {
				valueAccessorUnwrapped.disabledRanges.subscribe(function() {
					$(element).datepicker('destroy');
		    		ko.bindingHandlers.datepicker.setupComponent(element, valueAccessor, allBindingsAccessor);
		    		
		    	});
			}

			if(valueAccessorUnwrapped.promotionDates && $.isFunction(valueAccessorUnwrapped.promotionDates)) {
				valueAccessorUnwrapped.promotionDates.subscribe(function() {
					$(element).datepicker('destroy');
					ko.bindingHandlers.datepicker.setupComponent(element, valueAccessor, allBindingsAccessor);
				});
	    	}
		},
	    update: function(element, valueAccessor) {
	    	valueAccessorUnwrapped = ko.unwrap(valueAccessor())
	    	waveFlag = valueAccessorUnwrapped.mexicanWave || false;
	    	if(valueAccessorUnwrapped.initComponent){
	    		$(element).datepicker('destroy');
	    		ko.bindingHandlers.datepicker.setupComponent(element, valueAccessor);
	    	}
	    	
	    }
	};
	
});
